import { TransactionIntent } from '@carvana/merch-contracts';
import { nativeSrpPayload, nativeStcPayload } from '~/native/common/utils';

export enum TradeStatus {
  Active = 'Active',
  Expired = 'Expired',
  ExpiringSoon = 'ExpiringSoon',
  Pending = 'Pending',
  None = 'None'
}

export function getTradeCtaDetails(
  status: TradeStatus,
  intent: TransactionIntent,
  id: string
): { ctaHref: string; ctaText: string; nativePayload: string } {
  const isSellOrNotSure =
    intent === TransactionIntent.Sell || intent === TransactionIntent.NotSure;

  switch (status) {
    case TradeStatus.Active:
    case TradeStatus.ExpiringSoon:
      return isSellOrNotSure
        ? {
            ctaHref: `/sell-my-car/hub/${id}`,
            ctaText: 'continue',
            nativePayload: nativeStcPayload
          }
        : {
            ctaHref: '/cars',
            ctaText: 'shop with your trade-in',
            nativePayload: nativeSrpPayload
          };
    case TradeStatus.Expired:
      return {
        ctaHref: `/sell-my-car/hub/${id}`,
        ctaText: 'refresh your offer',
        nativePayload: nativeStcPayload
      };
    case TradeStatus.Pending:
      return {
        ctaHref: `/sell-my-car/hub/${id}`,
        ctaText: 'view details',
        nativePayload: nativeStcPayload
      };
    default:
      return {
        ctaHref: '/sell-my-car',
        ctaText: 'get your offer',
        nativePayload: nativeStcPayload
      };
  }
}

export const activeTradeStatuses: Partial<Record<TradeStatus, TradeStatus>> = {
  [TradeStatus.Active]: TradeStatus.Active,
  [TradeStatus.ExpiringSoon]: TradeStatus.ExpiringSoon
};
